<template>
  <div id="basic">
    <div class="top_div">
      <h5>当前时间：2020年05月20日 星期三 凌晨 00:50:30</h5>
      <div class="name_body">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="content_bottoma">当餐销售额</div>
              <div class="content_bottomb">￥0</div>
              <div class="content_bottom">日销售额 ￥0</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="content_bottoma">当餐客户数</div>
              <div class="content_bottomb">0</div>
              <div class="content_bottom">日客户数 0</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="content_bottoma">当餐食材消耗</div>
              <div class="content_bottomb">0.00KG</div>
              <div class="content_bottom">日客消耗 0.00KG</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="content_a">
                <div class="content_b">
                  <div class="content_bottoma">当餐菜品数</div>
                  <div class="content_bottomb size_text">0</div>
                </div>
                <div class="content_b">
                  <div class="content_bottoma">可用餐盘数</div>
                  <div class="content_bottomb size_text">0</div>
                </div>
              </div>
              <div class="content_b">
                <div class="content_bottoma">可用餐盘数</div>
                <div class="content_bottomb size_text">0</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-contents bg-purple">
              <div class="contents_h">就餐客户动态</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-contents bg-purple">
              <div class="contents_h">食材消耗动态</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-contents bg-purple">
              <div class="contents_h">食材剩余</div>
              <div>
                <div id="echartsDemo" style="width: 100%; height: 400px;"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-contents bg-purple">
              <div class="contents_h">食材消耗</div>
              <div>
                <div
                  id="echartsDemos"
                  style="width: 100%; height: 400px;"
                ></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-contents bg-purple">
              <div class="contents_h">店铺动态</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dailymenu',
  data() {
    return {
      content: '',
    };
  },
  mounted() {
    this.drawLine();
    this.drawLines();
  },
  methods: {
    drawLine() {
      let elementById = document.getElementById('echartsDemo');
      let echartsDemo = this.$echarts.init(elementById);
      let option = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: '业务指标',
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              textStyle: {
                fontSize: 15,
              },
            },

            axisLabel: {
              show: true,
            },
            data: [{ value: 1, name: '剩余占比量' }],
            center: ['50%', '40%'], // 默认全局居中
            radius: '50%',
            min: 0,
            max: 2,

            splitNumber: 2,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 3,
                color: [
                  [0.33, '#24d631'],
                  [0.66, '#2ac5ff'],
                  [1, '#f00'],
                ],
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 5, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: 'auto',
              },
            },
            splitLine: {
              // 分隔线
              length: 5, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto',
              },
            },
            pointer: {
              //指针长度
              length: '60%',
              width: 4,
              color: '#000',
            },
            title: {
              offsetCenter: [0, '65'], // x, y，单位px
              textStyle: {
                fontSize: 15,
              },
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },
    drawLines() {
      let elementById = document.getElementById('echartsDemos');
      let echartsDemo = this.$echarts.init(elementById);
      let option = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%',
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {},
          },
        },
        series: [
          {
            name: '业务指标',
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              textStyle: {
                fontSize: 15,
              },
            },

            axisLabel: {
              show: true,
            },
            data: [{ value: 1, name: '消耗占比量' }],
            center: ['50%', '40%'], // 默认全局居中
            radius: '50%',
            min: 0,
            max: 2,

            splitNumber: 2,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 3,
                color: [
                  [0.33, '#24d631'],
                  [0.66, '#2ac5ff'],
                  [1, '#f00'],
                ],
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 5, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: 'auto',
              },
            },
            splitLine: {
              // 分隔线
              length: 5, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: 'auto',
              },
            },
            pointer: {
              //指针长度
              length: '60%',
              width: 4,
              color: '#000',
            },
            title: {
              offsetCenter: [0, '65'], // x, y，单位px
              textStyle: {
                fontSize: 15,
              },
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f0f2f5;
  box-sizing: border-box;
  padding: 20px;
}
.top_div {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  background: none;
}
.name_body {
  width: 100%;
  min-height: 200px;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #fff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 182px;
  box-sizing: border-box;
  padding: 20px;
  position: relative;
}
.grid-contents {
  border-radius: 4px;
  min-height: 445px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.content_bottom {
  position: absolute;
  left: 20px;
  bottom: 0;
  font-size: 15px;
  line-height: 40px;
  border-top: solid 1px rgba(0, 0, 0, 0.3);
  width: 90%;
}
.content_bottoma {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 10px;
}
.content_bottomb {
  font-size: 30px;
  color: rgba(0, 0, 0, 0.85);
}
.content_a {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.content_b {
  min-width: 200px;
}
.size_text {
  font-size: 20px;
}
.contents_h {
  font-size: 15px;
  font-weight: 500;
  box-sizing: border-box;
  padding: 20px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
}
</style>
